export default {
  "menu": {
    "biocompatibility": "Biocompatibility",
    "truckSleeps": "Drowsiness events",
    "conduct": "Conduct",
    "sheetOfLife": "profile & history",
    "waitingTime": "Waiting periods",
    "assignment": "Assignation",
    "manager": "Manager task",
    "dataManagement": "Data management",
    "compliance": "Fulfillment",
    "ffdPvt": "Cognus",
    "ffdSleep": "Fitness for duty",
    "fleet": "Fleet",
    "inspections": "Inspections",
    "reports": "Reports"
  },
  "subMenu": {
    "summary": "Summary",
    "detail": "Detail",
    "driver": "Driver",
    "listOfVehicule": "Assignation list",
    "drivers": "Drivers",
    "pendingAssociationDrivers": "Unknown drivers",
    "team": "Equipments",
    "pendingAssociationTeam": "Unknown equipment",
    "semiTrailer": "Ramps",
    "pendingAssociationSemiTrailer": "Unknown ramps",
    "geozone": "Geo-zones",
    "tag": "Categories",
    "extendedProperty": "Additional attributes",
    "configuration": "Configuration",
    "users": "Users",
    "driverList": "Checklist’s list",
    "dynamicList": "Dynamic list",
    "workingShiftGroup": "Shift groups",
    "results": "Results"
  },
  "taskManagerIndicators": {
    "open": "Open deviations",
    "overdue": "Expired deviations"
  },
  "actions": {
    "expand": "Expand menu",
    "collapse": "Contract menu"
  },
  "reports": {
    "urlEmptyTitle": "Url not configured",
    "urlEmpty": "You do not have a url configured to view the reports.<br>Please contact the Gauss Control help desk.",
    "invalidUrlTitle": "invalid url",
    "invalidUrl": "The url <b>{externalUrl}</b> is not valid.<br>Please contact the Gauss Control Help Desk."
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/nav/index.js